import {
    Component,
    ElementRef,
    OnInit,
    TemplateRef,
    ViewChild,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ApiService } from 'app/core/services/api.service';
import { MappingService } from 'app/core/services/mapping.service';
import { UtilService } from 'app/core/services/util.service';
import { timeZonesDataNew } from 'environments/environment';

@Component({
    selector: 'import-csv',
    templateUrl: './import-csv.component.html',
    styleUrls: [],
})
export class ImportCsvComponent implements OnInit {
    mappingData: any;
    mappingField: any;
    timeZones: any = timeZonesDataNew;
    isCheckProspect: boolean = false;
    isLodingMapping: boolean = false;
    isCheckDuplicate: boolean = true;
    totalProspect: any;
    errorMessage: any;
    errorDialog: any;
    @ViewChild('errorModel') errorModel!: TemplateRef<ElementRef>;
    errNum: number;
    currentPath: string;
    serachMapping: string = '';
    constructor(
        private api: ApiService,
        private util: UtilService,
        private dialog: MatDialog,
        public mapping: MappingService
    ) {
        this.currentPath = window.location.pathname;
        this.api.isLoadSettings.subscribe((res: boolean) => {
            if (res == true) {
                this.mapping.isLoadMappingField.subscribe((res: boolean) => {
                    if (res == true) {
                        this.mappingField = this.mapping.mappingField;
                        this.mappingField.mappingKeys = [];
                        this.mappingField.forEach((field) => {
                            this.mappingField.mappingKeys.push({
                                key: field.column_key,
                                value: field.column_value,
                                icon: field.icon,
                            });
                        });
                        console.log();
                        console.log({
                            mappingField: this.mappingField,
                            mappingKeys: this.mappingField.mappingKeys,
                            'mapping column': this.mappingData?.columns,
                        });
                    }

                    this.mapping.isLoadMapping.subscribe((res: boolean) => {
                        if (res == true) {
                            this.mappingData = this.mapping.mappingData;
                            console.log('mappingData', this.mappingData);
                        }
                    });
                });

                console.log('mappingField', this.mappingField);
                console.log('mapping', this.mappingData);
            }
        });
    }

    ngOnInit(): void {}

    checkDuplicateProspect() {
        this.isCheckProspect = true;
        const fd = new FormData();
        fd.append('type', this.mapping.type);
        fd.append('type_id', this.mapping.activeListId);
        fd.append('is_check_duplicate', this.isCheckDuplicate ? '1' : '0');
        const newMappingField = {};
        this.mappingData.columns.forEach((column) => {
            for (const mapKey in this.mappingData) {
                newMappingField[column.key] = column.selectedValue;
                newMappingField['id'] = this.mappingData.id;
                newMappingField['type_id'] = this.mapping.activeListId;
                newMappingField['type'] = this.mapping.type;
                newMappingField['is_check_duplicate'] =
                    this.isCheckDuplicate == true ? 1 : 0;
            }
        });
        console.log({ newMappingField });
        let emailKey: string | null = null;
        for (const key in newMappingField) {
            if (Object.prototype.hasOwnProperty.call(newMappingField, key)) {
                if (newMappingField[key] === 'email') {
                    emailKey = key;
                    break; // Exit the loop after finding the first occurrence
                }
            }
        }

        if (emailKey) {
            console.log('The key with value "email" is:', emailKey);
        } else {
            console.log('No key with value "email" found');
        }

        fd.append('email', emailKey ? emailKey : '');
        this.api.postData('check-duplicate-upload-prospect', fd).subscribe({
            next: (res: any) => {
                if (res.success) {
                    this.isCheckProspect = true;
                    this.updateProspectMapping();
                } else {
                    this.isCheckProspect = false;
                    if (!res.tot_prospect) {
                        this.util.showToast(res.message, true);
                    }
                    this.totalProspect = res.tot_prospect;
                    if (this.totalProspect >= 0) {
                        const match = res.message.match(/(\d+)/);
                        this.errNum = match ? parseInt(match[1]) : null;
                        this.errorMessage = res.message;
                        if (res.errors) {
                            res.errors.forEach((err) => {
                                this.util.showToast(err, true);
                            });
                        }
                        this.errorDialog = this.dialog.open(this.errorModel, {
                            autoFocus: false,
                            width: '470px',
                            maxWidth: '470px',
                            panelClass: 'custom_modal',
                            disableClose: true,
                        });

                        this.errorDialog.afterClosed().subscribe({
                            next: (res: any) => {},
                        });
                    }
                }
            },
            error: (err) => {
                this.isCheckProspect = false;
                console.log('error', err);
            },
            complete() {},
        });
    }

    // update mapping data
    updateProspectMapping() {
        this.mapping.isLodingMapping = true;
        const fd = new FormData();
        const newMappingField = {};
        this.mappingData.columns.forEach((column) => {
            for (const mapKey in this.mappingData) {
                newMappingField[column.key] = column.selectedValue;
                newMappingField['id'] = this.mappingData.id;
                newMappingField['type_id'] = this.mapping.activeListId;
                newMappingField['type'] = this.mapping.type;
                newMappingField['is_check_duplicate'] =
                    this.isCheckDuplicate == true ? 1 : 0;
            }
        });
        fd.append('mapping', JSON.stringify(newMappingField));
        console.log('newMappingField', newMappingField);
        this.api.postData('update-upload-prospect-mapping', fd).subscribe({
            next: (res: any) => {
                if (res.success) {
                    this.isCheckProspect = false;
                    this.mapping.progressbarLoad = null;
                    this.mapping.progressbarLoad = '';
                    this.errorDialog.close();
                    if (res.batch) {
                        this.mapping.progressbarLoad = res.batch;
                        if (
                            res.batch.progress < 100 &&
                            (res.batch.cancelledAt == null ||
                                res.batch.finishedAt == null)
                        ) {
                            const paths = [
                                '/campaign/all/create-campaign/prospecting',
                                '/campaign-builder/create-campaign/prospecting',
                                '/campaign-builder/manage-campaign/prospecting',
                            ];
                            if (
                                paths.some(path => window.location.href.includes(path))
                            ) {
                                this.mapping.getMappingtProgress('prospecting');
                            } else if (
                                window.location.href.includes(
                                    '/prospect-management'
                                )
                            ) {
                                this.mapping.getMappingtProgress('prospects');
                            } else {
                                this.mapping.getMappingtProgress(
                                    'onboardingProspects'
                                );
                            }
                            this.mapping.isLodingMapping = true;
                        } else {
                            this.mapping.isLodingMapping = false;
                        }
                    }

                    this.dialog.closeAll();
                } else {
                    this.isCheckProspect = false;
                    this.mapping.isLodingMapping = false;
                    this.util.showToast(res.message, true);
                }
            },
            error: (err) => {
                this.isCheckProspect = false;
                this.mapping.isLodingMapping = false;
                console.log('error', err);
            },
            complete() {},
        });
    }

    getTimeZoneLabel(value: string): string {
        const timeZone = timeZonesDataNew.find((tz) => tz.value == value);
        return timeZone ? timeZone?.label : value;
    }

    getSelectedIcon(selectedValue: any): string {
        if (selectedValue && this.mappingField?.mappingKeys) {
            const matchedField = this.mappingField.mappingKeys.find(
                (field) => field.key == selectedValue
            );
            if (matchedField) {
                return matchedField.icon;
            }
        }
        return '';
    }

    getSelectedValue(value: any): string {
        if (value && this.mappingField?.mappingKeys) {
            const matchedField = this.mappingField.mappingKeys.find(
                (field) => field.key == value
            );
            if (matchedField) {
                return matchedField.value;
            }
        }

        return value ? value.toString() : '';
    }

    isOptionSelected(item: any): boolean {
        if (!this.mappingData?.columns) return false;
        return this.mappingData.columns.some(
            (column) =>
                column.selectedValue == item?.key &&
                item?.key != 'do_not_import' &&
                item?.key != 'custom_field'
        );
    }

    filterOptions(
        options: any[],
        searchTerm: string,
        selectedValue: string
    ): any[] {
        if (!searchTerm) {
            return options;
        }
        return options.filter(
            (option) =>
                option.key == selectedValue || // Always include the selected value
                (option.label &&
                    option.label
                        .toLowerCase()
                        .includes(searchTerm.toLowerCase())) ||
                (option.value &&
                    option.value
                        .toLowerCase()
                        .includes(searchTerm.toLowerCase()))
        );
    }
}
